import { useModel } from "hooks/useModel";
import Button from "pages/configurator/components/button";
import { FunctionComponent, useRef, useState } from "react";
import { useClickAway } from "react-use";
import { Configurator } from "@rromikas/configurio";
import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import NodesList from "../model-parts-list/nodes-list";
import { ADD_MEMBER_BUTTON_TEST_ID } from "constants/test";

interface GroupSwitcherProps {
  targetIndexes: number[];
  setTargetIndexes: (val: number[]) => void;
  model: ReturnType<typeof useModel>;
  customizers: Configurator["options"]["customizers"];
}

const GroupSwitcher: FunctionComponent<GroupSwitcherProps> = ({ targetIndexes, setTargetIndexes, model, customizers }) => {
  const nodes = Object.values(model.nodes);
  const [openSelections, setOpenSelections] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickAway(ref, () => setOpenSelections(false));
  return (
    <div>
      <div>
        <div className="mb-2 font-bold">Members</div>
        <div ref={ref} className="relative">
          <Button
            data-testid={ADD_MEMBER_BUTTON_TEST_ID}
            variant="secondary"
            onClick={() => setOpenSelections(true)}
            className="w-full mb-3"
          >
            Add member
          </Button>
          {!openSelections ? null : (
            <div className="absolute top-full translate-y-1 left-0 w-full z-20 max-h-[200px] overflow-auto ring-1 ring-main-to">
              <NodesList
                exclude={targetIndexes}
                onSelect={(index) => {
                  setTargetIndexes([...targetIndexes, index]);
                  setOpenSelections(false);
                }}
              />
            </div>
          )}
        </div>
      </div>
      <NodesList
        onSelect={() => {}}
        onRemove={(index) => {
          let arr = [...targetIndexes];
          const indexOfIndex = targetIndexes.findIndex((x) => x === index);
          if (indexOfIndex !== -1) {
            arr.splice(indexOfIndex, 1);
            setTargetIndexes(arr);
          }
        }}
        exclude={nodes.map((x, i) => (targetIndexes.includes(i) ? null : i)).filter((x) => x != null) as number[]}
      />
    </div>
  );
};

export default GroupSwitcher;
